import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Container, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { UserDataContext } from './Context';
import { validateToken } from './Utils';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {ListSubheader} from '@mui/material';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import DisplayLogo from './LogoDisplay';
import TurnedInOutlinedIcon from '@mui/icons-material/TurnedInOutlined';




  
function ListDividers({params}) {

  const listStyleDesktop = {
    
    width: '100%',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'background.paper',
  };

  
  const listStyleMobile = {...listStyleDesktop,display: {xs: "block",sm: "block", md: "none"},marginTop: 2,}
  
  const listItemeStyle = {
    display: 'flex',
    flexWrap: "wrap",
    justifyContent: 'space-between',
    alignContent: "center",
    width: '100%'
  }





  return (
    <Box >
    <List sx={listStyleDesktop}>
      <ListSubheader sx={{ display: {xs: "block", md: "none"},textAlign: "center",maxWidth: "300px",margin: "auto"}}>Item</ListSubheader>
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Ribbon Color :</Typography>
                  <Typography >{params.value.ribbonColor}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Print Color :</Typography>
                  <Typography>{params.value.fontColor}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Ribbon Lenght :</Typography>
                  <Typography>{params.value.ribbonLenght} yards</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Ribbon Width :</Typography>
                  <Typography>{params.value.ribbonWidth}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography  fontWeight='300'>Text On Ribbon :</Typography>
                  <Typography sx={{
                    
                    wordWrap: "break-word",
                    
                  }}
                  fontFamily={params.value.font}>
                    {params.value.textOnRibbon}
                  </Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
           
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300' >Logo On Ribbon :</Typography>
                  <Typography  >{params.value.uploaded_file_name}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Icon :</Typography>
                  <Typography>{params.value.icon}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Extra Options :</Typography>
                  <Typography>{params.value.comment}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Borders On Ribbon :</Typography>
                  <Typography>{params.value.ribbonBorderAdd ? "Yes" : ""}</Typography>
              </Box>
            </ListItem>
       </List>


       <List sx={listStyleMobile}>
        <ListSubheader   sx={{ textAlign: "center", maxWidth: "300px",margin: "auto"}}>Order</ListSubheader>
        
            
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Price :</Typography>
                  <Typography>{params.row.initial_price}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Qty :</Typography>
                  <Typography>{params.row.quantity}</Typography>
              </Box>
            </ListItem>
            <Divider component="li" />
            
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Total :</Typography>
                  <Typography>{params.row.total_price}</Typography>
              </Box>
            </ListItem>
            <ListItem>
              <Box sx={listItemeStyle}>
                  <Typography fontWeight='300'>Date :</Typography>
                  <Typography>{new Date(params.row.creation_date).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                              })
                  }
                  </Typography>
              </Box>
            </ListItem>
            </List>
       
    </Box>
  );
}

  




function OrderDetailsDialog({params}) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <React.Fragment>
       <Button  variant="outlined" color="primary" sx={{ fontSize: 12, width: "10px",height: "30px"}} onClick={() => setOpen(true)}>
        View
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle >Details</DialogTitle>
        <DialogContent dividers={false}>
          <ListDividers params={params} />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}




export default function UserOrdersDataGrid() {
  const [orderItems, setOrderItems] = React.useState([]);
  const [ribbonDetailes, setRibbonDetailes] = React.useState([])
  const [userData] = React.useContext(UserDataContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const fieldsForMobileView = ["id",  "product_name", "ribbon_detailes" ]
  const navigate = useNavigate()

  React.useEffect(() => {
    const fetchUserOrders = async () => {
      try {
        const token = await validateToken({ userData });
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getorderitems`, {
          credentials: "include",
          headers: { 
            Authorization: `Bearer ${token}` 
          },
        });

        if (response.ok) {
          const data = await response.json();
          setOrderItems(data);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    
   
    
    fetchUserOrders();

    
  }, [userData]);


 

  const columns = [
    { field: 'id', headerName: 'ID', flex: 0.2, align: 'center', headerAlign: 'center' },
    { 
      field: 'product_name',
      headerName: 'Item', 
      flex: 1.2, minWidth: 200, 
      align: 'center', 
      headerAlign: 'center',
      renderCell: (params) => (
        <Stack width="100%" direction="row" spacing={2} sx={{justifyContent: "flex-start",alignItems: "center"}}>
          <TurnedInOutlinedIcon fontSize="large" sx={{color: params.value.color}}/>
          <Typography 
            fontSize={14} 
            sx={{
              wordBreak: "break-word",
              overflowWrap: "break-word",
              whiteSpace: 'normal',
              }}>
            {params.value.text}
          </Typography>
          
        </Stack>  
        
         

      )
     },
    { field: 'initial_price', headerName: 'Price', flex: 0.6, minWidth: 100, align: 'center', headerAlign: 'center' },
    { field: 'quantity', headerName: 'Qty', flex: 0.5, align: 'center', headerAlign: 'center' },
    { field: 'total_price', headerName: 'Total', flex: 0.6, minWidth: 100, align: 'center', headerAlign: 'center' },
    {
      field: 'creation_date',
      headerName: 'Date',
      flex: 1,
      minWidth: 100,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontSize: "1rem" }}>
          {new Date(params.value).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                              })}
        </Typography>
      ),
    },
    {
      field: 'ribbon_detailes',
      headerName: 'Details',
      flex: 0.8,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        params.value= orderItems.filter((item) => item.id == params.row.id)[0]
        return(<OrderDetailsDialog params={params}/>);
      },
    },
    
  ];

  
  
  return (
    <Container sx={{ mt: 10}}>
      <Box  sx={{display: "flex", justifyContent: "center",my:3}}>
                    <DisplayLogo width={{xs: 80,md: 100}} height={{xs: 80,md: 100}} />
            </Box>
    <Box
      sx={{
        maxWidth: "100%",
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: 1,
        overflow: "hidden",
        p: 2,
      }}
    >
      <Typography variant="h6" sx={{ textAlign: "center ", mb: 2, fontSize: "1.2rem",justifyContent: "center"}}>
        Orders
      </Typography>
      <DataGrid
        columnVisibilityModel={Object.fromEntries(columns.map((obj) => [obj.field, isMobile ? fieldsForMobileView.includes(obj.field) : true ]))
         
            }

        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f8f9fa",
            fontSize: "1rem",
            fontWeight: "bold",
            textAlign: "center",
          },
          "& .MuiDataGrid-cell": {
            fontSize: isMobile ? "0.9rem" : "1rem",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "#f5f5f5",
          },
         
        }}
        rows={orderItems}
        columns={columns}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSorting
      />
    </Box>
    </Container>
  );
  
}


